resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
  Analytics

  Manages analytics data throughout the web app.

  Parameters:

  Methods (see methods for additional usage):

    pushEvent(eventName, paramteres, context)

    forcePush(dataLayerObject, context, parameterObject)

    update(newEventObj, newContext)

    updateEvents(newEventObj)

    updateContext(newContext)

    extendEventObject(eventObj)

*/

function Analytics (events, context) {
  this.uuid = null;
  this._pushed = {};
  this._events = events || {};
  this._context = context;
  this._DEBUG = false;

  this.constructor = function () {};

  this.constructData = function (evt) {
    this._createDebugCookies();

    var mogoUTM = this._getMogoUTM();
    var mCookie = this._getMCookie();
    var cid = this._getGoogleCid();

    var analytics = {
      'event': evt,
      'campaign_source': mogoUTM.Source,
      'campaign_medium': mogoUTM.Medium,
      'campaign_name': mogoUTM.Campaign,
      'campaign_content': mogoUTM.Content,
      'campaign_term': mogoUTM.Term,
      'gclid': mogoUTM.gclid,
      'google_cid': cid,
      'google_cid_rollup': '',
      'platform_used': 'web',
      'user_agent': navigator.userAgent,
      'url': location.pathname + location.search + location.hash
    };

    return analytics;
  };

  this._getGoogleCid = function () {
    try {
      if (typeof ga.getAll === 'function') {
        var trackers = ga.getAll();
        var i, len;
        for (i = 0, len = trackers.length; i < len; i += 1) {
          if (trackers[i].get('trackingId') === 'UA-707203-9') {
            return trackers[i].get('clientId');
          }
        }
      }
    } catch (e) {
      console.warn('trackers not loaded');
    }
  };

  this._createDebugCookies = function () {
    if (window.location.host !== 'www.mogo.ca' && location.hostname !== 'www.mogotrade.ca' && location.hostname !== 'mogotrade.ca') {
      Cookies('MogoUTM', 'Source:foo~Medium:bar~Campaign:foo~Content:bar~Term:foo~gclid:CLOHvabnzNECFVKPfgodYkMElA____1452886071200');
      Cookies('MCookie', '809046278.1452807293');
    }
  };

  this._getMogoUTM = function () {
    var obj = {};
    if (Cookies('MogoUTM')) {
      var str = Cookies('MogoUTM');
      var UTMs = str.split('____');
      UTMs.splice(1);
      UTMs = UTMs[0].split('~');
      for (i = 0; i < UTMs.length; i++) {
        UTMs[i] = UTMs[i].split(':');
        obj[UTMs[i][0]] = UTMs[i][1].replace('(', '').replace(')', '');
      }
    }
    return obj;
  };

  this._getMCookie = function () {
    if (Cookies('MCookie')) {
      return Cookies('MCookie');
    }
  };

  // Singleton
  window.mogo = window.mogo || {};
  window.mogo.registry = window.mogo.registry || {};
  if (typeof window.mogo.registry.Analytics === 'undefined') {
    window.mogo.registry.Analytics = this;
    this.constructor();
  }
  return window.mogo.registry.Analytics;
}

/*
  Deprecated: To match pushEvent signature. Please use forcePushEvent

  Pushes data to GA's dataLayer even if this data has already been pushed.

  Arguments:
    dataObject [object] (required):
      The data object to be pushed.
      E.g;
      {
        'CardStatus': Activated,
        'DashboardStatus': CheckMyRate, MogoMoney
      }

*/
Analytics.prototype.forcePush = function (dataObject, _context, paramObject) {
  console.warn('Analytics.forcePush is deprecated. Please use Analytics.forcePushEvent');
  if (typeof _context === 'undefined') _context = this;
  if (typeof paramObject === 'undefined') paramObject = {};

  var data = {};
  for (var prop in dataObject) {
    if (typeof dataObject[prop] === 'function') {
      var parameters = null;
      parameters = paramObject[prop];
      data[prop] = dataObject[prop].apply(_context, parameters);
    } else {
      data[prop] = dataObject[prop];
    }
  }
  dataLayer.push(data);
};

/*
  Pushes data to GA's dataLayer even if this data has already been pushed.

  Arguments:
    eventName [string] (required):
      The name of the analytics event in Analytics data.
    paramters [object]
      If the analytics event's associated data object has function
      definitions that take parameters, those parameters can be speicified
      in this object.
      E.g;
        {
          "event_function1": [param1, param2],
          "event_function2": [param3, param4]

        }
      The above parameter object can be passed for the following event object
      inside Analytics Data object:

      "sample-event": {
        "event_function1": function(param1, param2){ return true; },
        "event_function2": function(param3, param4){ return true; }
      }
    context [object]
      If you want to override the existing context or scope for methods'
      execution for data object construction.
*/
Analytics.prototype.forcePushEvent = function (eventName, parameters, context) {
  if (typeof this._events[eventName] === 'undefined') return;
  var data = this._getAnalyticsDataFor(eventName, parameters, context);
  dataLayer.push(data);
};

/*
  Check Analytics Data object for the event object, using which the
  data object for analytics is constructed and pushed to Analytic's
  data layer.

  Arguments:
    eventName [string] (required):
      The name of the analytics event in Analytics data.
    paramters [object]
      If the analytics event's associated data object has function
      definitions that take parameters, those parameters can be speicified
      in this object.
      E.g;
        {
          "event_function1": [param1, param2],
          "event_function2": [param3, param4]

        }
      The above parameter object can be passed for the following event object
      inside Analytics Data object:

      "sample-event": {
        "event_function1": function(param1, param2){ return true; },
        "event_function2": function(param3, param4){ return true; }
      }
    context [object]
      If you want to override the existing context or scope for methods'
      execution for data object construction.
*/
Analytics.prototype.pushEvent = function (eventName, parameters, context) {
  if (typeof this._events[eventName] === 'undefined') return;
  var data = this._getAnalyticsDataFor(eventName, parameters, context);
  this._push(eventName, data);
};

Analytics.prototype.update = function (newEventObj, newContext) {
  this._events = newEventObj;
  this._context = newContext;
};

Analytics.prototype.updateContext = function (newContext) {
  this._context = newContext;
};

Analytics.prototype.updateEvents = function (newEventObj) {
  this._events = newEventObj;
};

Analytics.prototype._getAnalyticsDataFor = function (eventName, paramObject, context) {
  var data = {};
  var eventData = this._events[eventName];
  var _context = this._context;
  if (context) { _context = context; }
  for (var prop in eventData) {
    if (typeof eventData[prop] === 'function') {
      var parameters = null;
      if (paramObject) { parameters = paramObject[prop]; }
      data[prop] = eventData[prop].apply(_context, parameters);
    } else {
      data[prop] = eventData[prop];
    }
  }
  return data;
};

/*
  Pushes data to GA's dataLayer only once.

  Arguments:
    eventName (string):
      Name of the event
    dataLayerObject [object] (required):
      The data object to be pushed.
      E.g;
      {
        'CardStatus': Activated,
        'DashboardStatus': CheckMyRate, MogoMoney
      }
*/
Analytics.prototype._push = function (eventName, dataObject) {
  if (typeof this._pushed[eventName] === 'undefined') {
    this._pushed[eventName] = {};
    this._pushed[eventName] = dataObject;
    dataLayer.push(dataObject);
  } else {
    if (JSON.stringify(this._pushed[eventName]) != JSON.stringify(dataObject)) {
      var dataLayerObject = Object.assign({}, dataObject);
      this._pushed[eventName] = dataLayerObject;
      dataLayer.push(dataObject);
    }
  }
};

/*
  Extends this._events object, which contains analytics data

  Arguments:
    data [object] (required):
      The analytics data object to be appended to this._events.
*/
Analytics.prototype.extendEventObject = function (eventObj) {
  if (typeof eventObj !== 'object') return;
  $.extend(this._events, eventObj);
};


/*
 Checks if Campaign exists in the dataLayer array.

  Arguments:
    prodCampaignNumber (number): production campaign number thats set in VWO
    testCampaignNumber (number): test environment campaign number thats set in VWO
*/

Analytics.prototype.isControlVersion = function (prodCampaignNumber, testCampaignNumber) {
  if (!prodCampaignNumber || !testCampaignNumber) return true;

  const controlKey = "Control";
  let campaignNumber = (window.location.host !== "www.mogo.ca" && window.location.host !== "www.mogotrade.ca" && window.location.host !== "mogotrade.ca") ? testCampaignNumber : prodCampaignNumber;
  let campaignName = `Campaign-${campaignNumber}`;

  let campaign = dataLayer.find((item) => {
    return item.hasOwnProperty(campaignName);
  });

  if (this._DEBUG) console.log(`Analytics JS: In ${campaignName}`);
  
  if (campaign) {
    return campaign[campaignName] === controlKey ? true : false;
  } else {
    return true;
  }
};
